import {
  FeedbackMetadataGrid,
  FeedbackMetadataGroupedByObjectID,
  FeedbackMetadataTypeHeader,
} from '@modules/feedback/components/FeedbackMetadata';
import { FeedbackMetadataField } from '@modules/feedback/types';
import { getFeedbackSourceMetadataGroupedByObjectID } from '@modules/feedback/utils';
import { Box, Paper } from '@mui/material';
import { ObjectType } from 'generated/graphql';

interface FeedbackDetailsMetadataCardProps {
  metadataFields: FeedbackMetadataField[];
  objectType: ObjectType;
  feedbackID: string;
}

export const FeedbackDetailsMetadataCard = ({
  metadataFields,
  objectType,
  feedbackID,
}: FeedbackDetailsMetadataCardProps) => {
  const objectTypeMetadataFields = metadataFields.filter(
    (metadataField) => metadataField.objectType === objectType,
  );

  const groupedByObjectID = getFeedbackSourceMetadataGroupedByObjectID({
    metadataFields: objectTypeMetadataFields,
  });

  const objectIDCount = Object.keys(groupedByObjectID).length;
  const shouldShowGroupedView = Object.keys(groupedByObjectID).length > 1;

  return (
    <Paper
      variant="outlined"
      sx={{
        pt: 3,
        borderRadius: 2,
      }}
    >
      <Box px={3}>
        <FeedbackMetadataTypeHeader
          objectType={objectType}
          objectIDCount={objectIDCount}
        />
      </Box>
      <Box>
        {shouldShowGroupedView ? (
          <Box p={3} pt={1.5}>
            <FeedbackMetadataGroupedByObjectID
              metadataFields={objectTypeMetadataFields}
              groupedByObjectID={groupedByObjectID}
              objectType={objectType}
              feedbackID={feedbackID}
            />
          </Box>
        ) : (
          <FeedbackMetadataGrid
            shouldLimitGridItems
            metadataFields={objectTypeMetadataFields}
            feedbackID={feedbackID}
            objectType={objectType}
          />
        )}
      </Box>
    </Paper>
  );
};
